import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import MenuBotones from "../../MenuBotones";

function BotonesReportes() {
  const { user } = useContext(AuthContext);
  const SECCIONES = [
    { section: "Reportes", items: [
      { label: "Reportes Ventas", icon: "fas fa-chart-line", color: "#3b82f6", href: "/MenuReportesVentas", desc: "Reportes de ventas", enabled: !!user.menu_reportes },
      { label: "Reportes Admin", icon: "fas fa-dollar-sign", color: "#10b981", href: "/MenuReportesAdmin", desc: "Reportes administrativos", enabled: !!user.menu_reportes },
      { label: "Dashboards", icon: "fas fa-chart-bar", color: "#6366f1", href: "/Dashboards", desc: "Tableros de control", enabled: !!user.menu_reportes },
    ]},
  ];
  return (
    <MenuBotones titulo="Reportes" descripcion="Menu de reportes" icono="fas fa-chart-bar" color="#3b82f6" secciones={SECCIONES} />
  );
}

export default BotonesReportes;
